
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"28","viewBox":"0 0 16 23"}, attrs),
              ...rest,
            },
            children.concat([_c('text',{attrs:{"data-name":"","transform":"translate(0 19)","fill":"#fff","font-size":"20","font-family":"HelveticaNeue, Helvetica Neue"}},[_c('tspan',{attrs:{"x":"0","y":"0"}},[_v('')])])])
          )
        }
      }
    